<div class="container">
  <h2>Configuratie van klantportaal</h2>
  <div *ngIf="loading" class="spinner-container">
    <mat-spinner diameter="48" color="primary"></mat-spinner>
  </div>
  <mat-card class="card">
    <div class="config-fields-container" *ngIf="!loading">
      <div class="upper-space">
        <textarea-input
          [title]="'Bovenste bannertekst'"
          [initContent]="portalNotification.text"
          [placeholder]="''"
          [client]="false"
          [sensitive]="true"
          (answer)="portalNotification.text = $event"
        ></textarea-input>
      </div>

      <yes-no
        [title]="'Banner weergeven'"
        [flexRow]="false"
        [nullIsFalse]="false"
        [value]="portalNotification.enabled"
        [neverShowExtraInstructions]="true"
        (answer)="portalNotification.enabled = $event"
      ></yes-no>
    </div>
  </mat-card>
  <div class="float-right" *ngIf="!loading">
    <button
      type="button"
      (click)="savePortalNotification()"
      mat-button
      class="button"
      id="btnSave"
    >
      Opslaan
    </button>
  </div>
</div>
